import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/supplierStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class SupplierStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

SupplierStrategy.title = actions.title
const option = {
  value: 'create_supplier',
  display: 'Create Suppliers',
  category: 'suppliers',
  Component: SupplierStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
SupplierStrategy.option = option
